import { render } from "./DockRight.vue?vue&type=template&id=6c9cb146"
import script from "./DockRight.vue?vue&type=script&lang=js"
export * from "./DockRight.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/DockRight.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6c9cb146"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6c9cb146', __exports__)) {
    api.reload('6c9cb146', __exports__)
  }
  
  module.hot.accept("./DockRight.vue?vue&type=template&id=6c9cb146", () => {
    api.rerender('6c9cb146', render)
  })

}


export default __exports__